export default __webpack_public_path__ + "static/media/bet25sport_logo.d4874d55.svg";